<div class="cm-footer">
	<div class="cm-landing-fixed-width">
		<div class="cm-footer__newsletter__header-group">
			<span class="cm-footer__newsletter__header">
				Newsletter
			</span>
			<span class="cm-footer__newsletter__p">
				Sign up to our newsletter for CropManage workshop announcements and updates.
			</span>
		</div>
		<form (ngSubmit)="submit()" [formGroup]="form">
			<div class="cm-footer__newsletter__input">
				
				<label>Email:</label>
				<div style="position:relative;">
					<input type="text"
						name="email"
						formControlName="Email"
						placeholder="Your Email"/>
					<button class="cm-subscribe-button"
						type="submit">
						Subscribe
					</button>
					<input
						formControlName="Company"
						type="text"
						tabindex="-1"
						autocomplete="off"
						class="hp"
						aria-hidden="true"
					/>
				</div>
			</div>
		</form>
		<div class="cm-footer__mid">
			<img src="../assets/images/logos/landing-page/cropmanage-white-logo.svg"
				width="298" height="54"/>
			<div class="cm-footer__mid__right">
				<div class="cm-footer__mid__right__links">
					<div class="cm-footer__mid__right__links__link">
						<h4>About</h4>
						<ul>
							<li routerLink="/about-us">About Us</li>
							<li routerLink="/research-studies/">Research Studies</li>
						</ul>
					</div>
					<div class="cm-footer__mid__right__links__link">
						<h4>Resources</h4>
						<ul>
							<li><a href="https://help.cropmanage.ucanr.edu/" target="_blank">Tutorials</a></li>
							<li routerLink="/contact-us">Contact Us</li>
						</ul>
					</div>
					<div class="cm-footer__mid__right__links__link">
						<h4>Tools</h4>
						<ul>
							<li routerLink="et-calculator">Seasonal ET Calculator</li>
							<li routerLink="ir-calculator">Irrigation Calculator</li>
							<li><a href="https://api.cropmanage.ucanr.edu/" target="_blank">Web API</a></li>
						</ul>
					</div>
					<div class="cm-footer__mid__right__links__link">
						<h4>Get Involved</h4>
						<ul>
							<li routerLink="/community">Community</li>
							<li><a href="{{ donationLink }}" target="_blank">Donate</a></li>
						</ul>
					</div>
				</div>
				<button class="cm-login-button"
					routerLink="/login">
					Log In
					<mat-icon class="material-symbols-outlined">keyboard_arrow_right</mat-icon>
				</button>
			</div>
		</div>
		<div class="cm-footer__copyright">
			<span>Copyright © 2025 All rights reserved.</span>
			<div class="cm-footer__copyright__right">
				<a routerLink="/privacyPolicy">Privacy Policy</a>
				<a routerLink="/termsOfUse">Terms of Use</a>
				<a href="http://ucanr.edu/sites/anrstaff/Diversity/Affirmative_Action/Resources/Policy-related_downloads/"
					target="_blank">
					Disclaimer
				</a>
				<a href="http://ucanr.edu/Accessibility/" target="_blank">
					Accessibility
				</a>
			</div>
		</div>
	</div>
</div>